import type { FC } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { usePopover } from 'src/hooks/use-popover';
import { KeyboardArrowDown } from '@mui/icons-material';
import { ListItemIcon, Typography } from '@mui/material';

interface MultiSelectProps {
  label: string;
  onChange?: any;
  options: { label: string; value: unknown; icon: any; id?: string }[];
  selectedValue?: any;
  resetVal?: any;
}

export const MultiSelect: FC<MultiSelectProps> = (props: any) => {
  const { label, onChange, options, resetVal, selectedValue, ...other } = props;
  const popover = usePopover<HTMLButtonElement>();

  const handleValueChange = (e: any) => {
    if (selectedValue === e) {
      resetVal('');
      popover.handleClose();
      return;
    }
    onChange(e);
    popover.handleClose();
  };

  return (
    <>
      <Button
        sx={{
          color: '#111927',
          fontWeight: '600',
          padding: '0',
        }}
        endIcon={<KeyboardArrowDown />}
        onClick={popover.handleOpen}
        ref={popover.anchorRef}
        {...other}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: '13px',
            color: '#6C737F',
          }}
          noWrap={true}
        >
          {label}
        </Typography>
      </Button>
      <Menu
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
        onChange={handleValueChange}
      >
        {options.map((option: any) => (
          <MenuItem
            key={option.label}
            value={option.value}
            onClick={() => handleValueChange(option.value)}
            sx={{
              background: selectedValue === option.value ? ' rgb(128, 128, 128,0.1)' : 'none',
            }}
          >
            <ListItemIcon>{option.icon}</ListItemIcon>
            <Typography
              sx={{
                color: '#111927',
                fontSize: '12px',
                fontWeight: 400,
              }}
            >
              {option.label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
